module.exports = __webpack_public_path__ + "img/icon_section_energia.b2234270.svg";